'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocale = undefined;

var _reselect = require('reselect');

/* SELECTORS */
var intlSelector = (0, _reselect.createSelector)(function (state) {
  return state;
}, function (s) {
  return s.intl;
});

var getLocale = exports.getLocale = (0, _reselect.createSelector)(intlSelector, function (intl) {
  return intl.locale || 'en';
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/intl.js
// module id = dYLj
// module chunks = 57